import { render } from "./NetworkError.vue?vue&type=template&id=48c3aea0&scoped=true&ts=true"
import script from "./NetworkError.vue?vue&type=script&lang=ts"
export * from "./NetworkError.vue?vue&type=script&lang=ts"

import "./NetworkError.vue?vue&type=style&index=0&id=48c3aea0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c3aea0"]])

export default __exports__